/**
 * Build a browser-loadable profile image URL.
 * Matches HorizontalNavigation / UserProfilePage: relative /uploads/... must hit the API host.
 */

/** Resolve a stored profile path (/uploads/..., https, etc.) for <img src>. */
export function resolveProfileImageUrl(imageUrl: string | null | undefined): string | null {
  if (!imageUrl) return null;
  const raw = String(imageUrl).trim();
  if (!raw) return null;

  if (/^https?:\/\//i.test(raw) || raw.startsWith('blob:') || raw.startsWith('data:')) {
    return raw;
  }

  // s3:// is not browser-loadable; auth APIs should already convert to https
  if (raw.startsWith('s3://')) return null;

  // Same default host as HorizontalNavigation (backend serves /uploads in local/dev)
  const apiUrl = (
    (import.meta as { env?: { VITE_API_URL?: string } }).env?.VITE_API_URL ||
    'http://localhost:3000'
  ).replace(/\/$/, '');

  const imagePath = raw.startsWith('/') ? raw : `/${raw}`;
  const encodedPath = imagePath
    .split('/')
    .map((part) => (part ? encodeURIComponent(part) : ''))
    .join('/');
  return `${apiUrl}${encodedPath}`;
}

export function getUserProfilePictureUrl(user: {
  profileImageUrl?: string | null;
  preferences?: { profile_image_url?: string | null };
} | null | undefined): string | null {
  if (!user) return null;
  return resolveProfileImageUrl(
    user.profileImageUrl || user.preferences?.profile_image_url || null
  );
}
